var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
var wrapStyle = {
    border: '1px solid #d4dbe3',
    borderRadius: '10px',
    background: '#fff',
    marginBottom: '22px',
    overflowX: 'auto',
};
var thStyle = {
    textAlign: 'left',
    fontSize: '12px',
    color: '#5d6b7a',
    fontWeight: 600,
    padding: '10px 14px',
    borderBottom: '1px solid #e1e7ee',
    whiteSpace: 'nowrap',
};
var tdStyle = {
    fontSize: '13px',
    padding: '9px 14px',
    borderBottom: '1px solid #eef2f6',
};
/**
 * AV-03 top-failing-rules table — the most-failing rules across all categories,
 * ordered by affected-record count, with a per-row drill-through to the records
 * list filtered by that issue code (scenario steps 6–7).
 */
export var RuleFailureTable = function (_a) {
    var rules = _a.rules, onDrillToRule = _a.onDrillToRule;
    var intl = useIntl();
    if (!rules || rules.length === 0) {
        return null;
    }
    return (React.createElement("div", { style: wrapStyle, "data-test-rule-failure-table": true },
        React.createElement("h3", { style: { margin: 0, padding: '12px 14px 6px', fontSize: '14px', fontWeight: 700 } },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.topRules.title" })),
        React.createElement("table", { style: { width: '100%', borderCollapse: 'collapse', minWidth: '520px' } },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { scope: "col", style: thStyle },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.topRules.rule" })),
                    React.createElement("th", { scope: "col", style: thStyle },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.topRules.category" })),
                    React.createElement("th", { scope: "col", style: __assign(__assign({}, thStyle), { textAlign: 'right' }) },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.topRules.records" })),
                    React.createElement("th", { scope: "col", style: __assign(__assign({}, thStyle), { textAlign: 'right' }) },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.topRules.violations" })),
                    React.createElement("th", { scope: "col", style: thStyle },
                        React.createElement("span", { style: {
                                position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0 0 0 0)',
                            } },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.topRules.drill" }))))),
            React.createElement("tbody", null, rules.map(function (r) { return (React.createElement("tr", { key: r.code, "data-test-rule-row": r.code },
                React.createElement("td", { style: tdStyle },
                    React.createElement("span", { "data-test-rule-label": true }, r.label || r.code)),
                React.createElement("td", { style: tdStyle },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.category.".concat(r.category) })),
                React.createElement("td", { style: __assign(__assign({}, tdStyle), { textAlign: 'right' }) },
                    React.createElement(FormattedNumber, { value: r.records })),
                React.createElement("td", { style: __assign(__assign({}, tdStyle), { textAlign: 'right' }) },
                    React.createElement(FormattedNumber, { value: r.violations })),
                React.createElement("td", { style: __assign(__assign({}, tdStyle), { textAlign: 'right' }) },
                    React.createElement("button", { type: "button", onClick: function () { return onDrillToRule(r.code); }, "data-test-rule-drill": r.code, "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.corpusQuality.topRules.drill.aria' }, { rule: r.label || r.code }), style: {
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            color: '#2c5cc5',
                            font: 'inherit',
                            textDecoration: 'underline',
                        } },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.topRules.drill" }))))); })))));
};
